// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Mudumbai Project Firebase Configuration
// Project ID: wordfun-dcd3b
const firebaseConfig = {
  apiKey: "AIzaSyBUy9FR3sx_gznZXa0i-4N2f9j6MXOPu2o",
  authDomain: "wordfun-dcd3b.firebaseapp.com",
  databaseURL: "https://wordfun-dcd3b-default-rtdb.firebaseio.com",
  projectId: "wordfun-dcd3b",
  storageBucket: "wordfun-dcd3b.firebasestorage.app",
  messagingSenderId: "830624246372",
  appId: "1:830624246372:web:ff9aec1757ae81d3ef0d71",
  measurementId: "G-6NTQ1X6EXE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with the "jayram" database
export const db = getFirestore(app, "jayram");

// Initialize Storage
export const storage = getStorage(app);

// Initialize Auth
export const auth = getAuth(app);

export default app;